import styled from 'styled-components'
import AceEditor from 'react-ace'

export const PageWrap = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;

    background: ${p => p.theme.backgroundColor};
`

const Window = `
    width: 100%;
    height: 100%;
    padding: 20px;
`

export const EditorWindow = styled.div`
    border-right: 1px solid ${p => p.theme.accentColor};
    ${Window};
`

export const Editor = styled(AceEditor)`
    width: 100%;
    height: 100%;
    background-color: #2c3e50 !important;
`

export const PreviewWindow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${Window};
`

export const LoaderTint = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    background: rgba(0, 0, 0, 0.3);
    z-index: 10;
`



// WEBPACK FOOTER //
// ./src/pages/NewShare.styles.js